import React, { Component, Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Tab,
  Tabs,
  TextField,
  Typography,
  withStyles
} from '@material-ui/core';
import {
  AvatarGroup,
  ToggleButton,
  ToggleButtonGroup,
} from '@material-ui/lab'
import { GROUP_NAMES } from '../utils/lists'
import Cookies from 'universal-cookie'
import { config } from '../config.js'

const API = config.api.TRAVEL_URL
const cookies = new Cookies();

const CustomTab = ({ className, children }) => {
  return <Box component="div" className={className} children={children} />;
};

class GroupsBar extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isSubmitting: false,
      openedNewGroupDialog: false,
      group_name: "",
    };
  }

  handleCloseNewGroup = () => {
    this.setState({
      openedNewGroupDialog: false,
      group_name: "",
    })
  }

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value, error: null});
  }

  handleCreateGroup = () => {
    this.setState({isSubmitting: true})
    const user_jwt_token = cookies.get('jwt')

    if (this.props.user.is_registered && user_jwt_token !== undefined) {
      fetch(config.api.TRAVEL_URL + '/groups', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user_jwt_token}`,
        },
        dataType: 'json',
        // We convert the React state to JSON and send it as the POST body
        body: JSON.stringify({
          group: {
            name: this.state.group_name,
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        this.setState({isSubmitting: false})

        if (data.group && data.group.id) {
          this.props.onUserUpdated(data.user)
          this.props.history.push(`/group/${data.group.id}`)
        }
      })

    } else {
      this.openSigninModal()
    }
  }

  render() {
    const {
      classes
    } = this.props

    return (
      <Fragment>
        <Tabs
          value={false}
          variant="scrollable"
          scrollButtons="off"
          aria-label="scrollable auto"
          // classes={{flexContainer: classes.flexContainer}}
        >
            <CustomTab key={-1}>
              <ToggleButtonGroup size="small">
                <ToggleButton value="planning" disableRipple selected={true} classes={{root: classes.buttonOutlined, selected: classes.buttonOutlinedSelected, label: classes.groupLabel}}>
                  <Avatar key={-1} className={classes.avatarSmall} src={this.props.user.image} alt={this.props.user.first_name}/>
                  Solo
                </ToggleButton>
                {this.props.user.groups && this.props.user.groups.map((group, i) => {
                  return <ToggleButton key={i} value={group.group_id} disableRipple classes={{root: classes.buttonOutlined, selected: classes.buttonOutlinedSelected, label: classes.groupLabel}} onClick={() => this.props.history.push(`/group/${group.group_id}`)}>

                    {group.members && group.members.length > 1 ?
                      <AvatarGroup classes={{avatar: classes.avatarGroupSmall, root: classes.avatarGroup}} max={2}>
                        {group.members.map((member, i) => {
                          return <Avatar key={i} className={classes.avatarGroupSmall} src={member.image}/>
                        })}
                      </AvatarGroup>
                    :
                      <AvatarGroup classes={{avatar: classes.avatarGroupSmall, root: classes.avatarGroup}} max={2}>
                        <Avatar key={0} className={classes.avatarGroupSmall}/>
                        <Avatar key={1} className={classes.avatarGroupSmall}/>
                        <Avatar key={2} className={classes.avatarGroupSmall}/>
                        <Avatar key={3} className={classes.avatarGroupSmall}/>
                        <Avatar key={4} className={classes.avatarGroupSmall}/>
                      </AvatarGroup>
                    }
                    {(group.name && group.name.substring(0, 17)) || 'Friends'}
                  </ToggleButton>
                })}
                <ToggleButton value="new" disableRipple onClick={() => this.setState({openedNewGroupDialog: true})} classes={{root: classes.buttonOutlined, selected: classes.buttonOutlinedSelected, label: classes.groupNewLabel}}>
                  <Avatar key={-2} className={classes.avatarSmall} style={{backgroundColor: 'transparent', color: '#02c39a'}}>
                    <Icon className={`material-icons-outlined notranslate`} style={{fontSize: 30, margin: 0, color: '#02c39a'}}>group_add</Icon>
                  </Avatar>
                  New group
                </ToggleButton>
              </ToggleButtonGroup>
            </CustomTab>
        </Tabs>

        <Dialog classes={{root: classes.newGroupDialogRoot, paper: classes.newGroupDialogPaper}} disableBackdropClick={true} disableEscapeKeyDown={true} aria-labelledby="customized-dialog-title" fullWidth={true} maxWidth={'sm'} open={this.state.openedNewGroupDialog}>
          <DialogTitle id="customized-dialog-title">
            <IconButton aria-label="close" className={classes.closeButton} onClick={this.handleCloseNewGroup}>
              <Icon className="notranslate">close</Icon>
            </IconButton>
            <Box style={{marginTop: 7, float: 'left'}}>
              New travel group
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <TextField
              autoFocus={false}
              name="group_name"
              label=""
              placeholder="Name"
              helperText=""
              variant="outlined"
              margin="dense"
              value={this.state.group_name}
              onChange={this.handleChange}
              className={classes.textfield}
            />
            <Typography gutterBottom style={{fontSize: 12, color: '#828282', fontWeight: 500}}>
              <Icon className={`material-icons-outlined notranslate ${classes.icon}`}>lock</Icon> This name will be visible only to you
              <br/><br/>
            </Typography>
            <Typography style={{color: '#555', fontSize: 14, marginLeft: 10, marginTop: 10, fontWeight: 600}}>Suggestions</Typography>
            <List className={classes.menu}>
            {GROUP_NAMES.map((group_name, i) => {
              return <ListItem button key={group_name.title}
                      onClick={() => this.setState({group_name: group_name.title})}
                      >
                  <ListItemIcon><Icon className={`material-icons-outlined notranslate ${classes.listItemIcon}`} style={{color: '#02c39a'}}>{group_name.icon}</Icon></ListItemIcon>
                  <ListItemText primary={group_name.title} classes={{primary: classes.listItemText, secondary: classes.listItemTextSecondary}} />
              </ListItem>
            })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button disabled={this.state.group_name.trim() !== '' ? false : true} variant="contained" onClick={this.handleCreateGroup} color="primary" className={classes.buttonBook} >
              {this.props.isSubmitting ?
                <Fragment>Creating...</Fragment>
                :
                <Fragment>Create</Fragment>
              }
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    )
  }
}

const styles = theme => ({
  avatarGroup: {
    justifyContent: 'center',
    // marginRight: 5,
  },
  avatarGroupSmall: {
    width: 35,
    height: 35,
    fontSize: '15px',
    backgroundColor: '#fff',
    color: '#777',
    borderColor: '#e7e7e7',
    marginRight: -2,
  },
  avatarSmall: {
    width: 35,
    height: 35,
    fontSize: '15px',
    backgroundColor: '#fff',
    color: '#02c39a',
    borderColor: '#02c39a',
    float: 'none',
    margin: '0px auto 3px auto',
  },
  groupLabel: {
    display: 'block',
  },
  groupNewLabel: {
    display: 'block',
    backgroundColor: 'transparent !important',
    // border: '1px dashed #e7e7e7 !important',
  },
  buttonOutlined: {
    // color: '#1bb746',
    float: 'left',
    // marginLeft: 10,
    padding: 0,
    borderRadius: 20,
    fontWeight: 600,
    border: '1px solid transparent',
    color: '#333',
    marginTop: 6,
    minWidth: 80,
    backgroundColor: 'transparent',

    '& .material-icons': {
      marginRight: 5,
      color: '#777',
      fontWeight: 500,
      padding: 0,
    },

    '& > .MuiToggleButton-label': {
      // backgroundColor: '#f5f5f5',
      padding: '10px 15px 10px 15px',
      borderRadius: 15,
      border: '1px solid transparent',
    },

    '&:hover > .MuiToggleButton-label': {
      backgroundColor: '#fff !important',
      padding: '10px 15px 10px 15px',
      borderRadius: 15,
      // boxShadow: '0px 3px 3px -2px rgb(0 0 0 / 5%), 0px 3px 4px 0px rgb(0 0 0 / 5%), 0px 1px 8px 0px rgb(0 0 0 / 5%)',
      border: '1px solid #e7e7e7',
    },

    '&:hover': {
      backgroundColor: 'transparent',
    },

    '&:not(:first-child)': {
      marginLeft: 5,
    },

    '&:hover .material-icons': {
      color: '#333',
    },
  },
  buttonOutlinedSelected: {
    backgroundColor: 'transparent !important',
    fontWeight: 600,
    color: '#333 !important',
    padding: '5px 0px',
    minWidth: 80,

    '& .material-icons': {
      color: '#02c39a !important',
    },

    '&:hover': {
      color: '#333',
    },

    '&:hover .material-icons': {
      color: '#333',
    },

    '& > .MuiToggleButton-label': {
      borderRadius: 15,
      backgroundColor: '#fff',
      padding: '10px 15px',
      // boxShadow: '0px 3px 3px -2px rgb(0 0 0 / 5%), 0px 3px 4px 0px rgb(0 0 0 / 5%), 0px 1px 8px 0px rgb(0 0 0 / 5%)',
      border: '1px solid #e7e7e7',
    },

    '&:hover > .MuiToggleButton-label': {
      padding: '10px 15px',
    }
  },
  closeButton: {
    float: 'right',
  },
  newGroupDialogRoot: {
    textAlign: 'left'
  },
  newGroupDialogPaper: {
    margin: 10,
    width: '100%',
  },
  textfield: {
    backgroundColor: '#fff',
    marginTop: 5,
    width: '94%',
    borderRadius: 50,
    borderWidth: 1,
    padding: 9,
    boxShadow: '0 2.5px 5px 0 rgba(0, 0, 0, 0.05)',
    fontWeight: 500,
    border: '1px solid #eee',

    '& fieldset': {
      borderColor: 'transparent !important',
      borderWidth: 1,
      borderRadius: 25,
      paddingLeft: 30,
      fontWeight: 500,
    },

    '&:hover fieldset': {
      borderColor: 'transparent !important',
      borderWidth: 1,
      borderRadius: 25,
      paddingLeft: 30,
    },
  },
  listItemIcon: {
    color: '#02c39a',
  },
  listItemText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#000',
    maxWidth: '78%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextSecondary: {
    fontSize: 14,
    fontWeight: 600,
    maxWidth: '78%',
    display: 'block',
    overflow: 'hidden',
    // whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  icon: {
    fontSize: 14,
    fontWeight: 600,
    marginTop: -3,
    marginRight: 0,
    marginLeft: 10,
    padding: '5px !important',
    verticalAlign: 'middle',
    color: '#828282',
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 10px 10px 10px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    // boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    padding: '13px 30px',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
  flexContainer: {
    justifyContent: 'flex-end',
  },
});

export default withStyles(styles)(withRouter(GroupsBar));
